import { getLocale } from "../runtime";

const sv_applied = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillämpad`
};

const applied = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_applied(inputs)
	return "applied";
};

export { applied as "applied" };